export function isMobileDevice() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 检查移动设备
    if (/windows phone/i.test(userAgent)) {
        return true;
    }
    if (/android/i.test(userAgent)) {
        return true;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
    }

    // 其他情况认为是PC端
    return false;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js